import { ScheduleSummary } from './../../../api/models/schedule-summary.model';
import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';


export const themeScheduleSummaryAdapter: EntityAdapter<ScheduleSummary> = createEntityAdapter<ScheduleSummary>({
    selectId: (summary: ScheduleSummary) => summary.Id
})

export interface ThemeScheduleSummaryState extends EntityState<ScheduleSummary> {
    total: number;
    loaded: boolean;
    ids: number[];
    entities: any;
}